// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8792) return "main.4475a1abc416cefed0a8.css";
	// return url for filenames based on template
	return chunkId + "." + "d6e8d88ddbc94e5c4f62" + "." + chunkId + ".css";
};